module.exports = __webpack_public_path__ + "img/code_56616C6572697573.9f1a5d73.svg";